// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-xug1tv","logo":"logo-jg6auZ","title":"title-sh6m0o"};